import { Box } from "@mui/system";
import React from "react";
import { UNSUBSCRIBE_ICON } from "../../utils/constants/assets";
import { styles } from "./styles";
import { GREY } from "../../utils/constants/colors";
import { fontWeight } from "../../utils/constants/UI";
import { STRINGS } from "./strings";
import Image from "../../components/Image/Image";
import TypographyInline from "../../components/Typography/TypographyInline";

const UnsubscribeScreen = () => {
  const classes = styles();

  return (
    <Box className={classes.unsubscribePage}>
      <Box className={classes.unsubscribeCard}>
        <Box className={classes.unsubscribeIconRing}>
          <Box className={classes.unsubscribeIconInner}>
            <Image src={UNSUBSCRIBE_ICON} />
          </Box>
        </Box>
        <Box className={classes.unsubscribeTextWrap}>
          <TypographyInline
            size={"dsm"}
            color={GREY.PRIMARY}
            fontWeight={fontWeight.SEMIBOLD}
            label={STRINGS.UNSUBSCRIBE}
          />
          <TypographyInline
            size={"md"}
            color={GREY.SECONDARY}
            fontWeight={fontWeight.REGULAR}
            label={STRINGS.MORE_EMAIL}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default UnsubscribeScreen;
